import { Intersection, Object3D } from "three";
import { Editor } from "./editor.js";

export class Selector {

  editor:Editor;
	constructor( editor:Editor ) {

		const signals = editor.signals;

		this.editor = editor;

		// signals

		signals.intersectionsDetected.add( ( intersects:Intersection[] ) => {

			if ( intersects.length > 0 ) {

				const object = intersects[ 0 ].object;

				if ( object.userData.object !== undefined ) {

					// helper

					this.select( object.userData.object );

				} else {

					this.select( object );

				}

			} else {

				this.select( null );

			}

		} );

	}

	select( object?:Object3D|null ) {
    if(object===undefined){
      object=null;
    }

		if ( this.editor.selected === object ) {
			return;
		}

		this.editor.selected = object;

		this.editor.signals.objectSelected.dispatch( object );

	}

	deselect() {

		this.select( null );

	}

}
